import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faShieldAlt,
    faSearch,
    faBalanceScale,
    faCogs,
    faTasks,
    faChartLine,
    faEnvelope
} from '@fortawesome/free-solid-svg-icons';
import AOS from 'aos';
import 'aos/dist/aos.css';

// import NSSNavbar from './NSSNavbar';
// import Footer from './Footer';

const services = [
    { icon: faShieldAlt, title: 'Risk Management', description: 'Identify, assess, and mitigate potential risks before they impact business operations.' },
    { icon: faSearch, title: 'Compliance Assurance', description: 'Ensure your company complies with regulations, policies, and industry standards.', color: 'text-success' },
    { icon: faBalanceScale, title: 'Internal Controls', description: 'Evaluate and strengthen internal controls to prevent errors and fraud.', color: 'text-warning' },
    { icon: faCogs, title: 'Operational Efficiency', description: 'Identify gaps in processes and recommend improvements for smooth operations.', color: 'text-info' },
    { icon: faTasks, title: 'Process Evaluation', description: 'Review key business processes to ensure they align with organizational objectives.', color: 'text-danger' },
    { icon: faChartLine, title: 'Performance Insights', description: 'Provide insights that support management in making strategic business decisions.' },
];

const reasons = [
    { title: 'Proactive Risk Approach', description: 'We help organizations anticipate challenges rather than react to them.' },
    { title: 'Tailored Methodology', description: 'Our audits are customized to your organization’s size, industry, and goals.' },
    { title: 'Objective Perspective', description: 'Gain independent insights into your operations and governance structures.' },
    { title: 'Operational Improvement', description: 'We don’t just identify gaps—we provide solutions to enhance performance.' },
    { title: 'Confidentiality & Trust', description: 'We handle sensitive data with utmost care and discretion.' },
    { title: 'Dedicated Expertise', description: 'Our experienced auditors bring deep industry knowledge and practical advice.' },
];

const InternalAudit = () => {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const sectionStyles = {
        padding: '80px 0',
        fontFamily: 'Segoe UI, sans-serif'
    };

    const leadStyle = {
        color: '#6c757d',
        fontSize: '1.25rem'
    };

    const cardBaseStyle = {
        borderRadius: '15px',
        transition: 'all 0.3s ease',
        height: '100%',
        cursor: 'pointer'
    };

    const handleMouseEnter = (e) => {
        e.currentTarget.style.backgroundColor = '#7f8986ff';
        e.currentTarget.style.color = '#fff';
        e.currentTarget.style.transform = 'translateY(-8px)';
        e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
    };

    const handleMouseLeave = (e) => {
        e.currentTarget.style.backgroundColor = '#fff';
        e.currentTarget.style.color = '#000';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
    };

    return (
        <>
            {/* <NSSNavbar /> */}

            {/* Hero Section */}
            <section
                style={{
                    position: "relative",
                    height: "90vh",
                    backgroundImage: `url('./em3.png')`, // put your internal audit image in public folder
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                <div style={{ background: "rgba(0,0,0,0.4)", padding: "20px", borderRadius: "10px" }}>
                    <p style={{ fontSize: "1.2rem" }}>Strengthening businesses through proactive audits</p>
                    <h1 style={{ fontWeight: "bold", fontSize: "2.5rem" }}>Independent insights for stronger controls and sustainable growth</h1>
                    
                    {/* WhatsApp Button */}
                    <a
                        href="https://wa.me/+971588124755"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="whatsapp-btn"
                    >
                        <i className="bi bi-whatsapp me-2"></i> Chat on WhatsApp
                    </a>
                </div>
            </section>

            <main>
                {/* Intro Section */}
                <section style={{ ...sectionStyles, backgroundColor: '#fff' }}>
                    <Container>
                        <p style={leadStyle} data-aos="fade-up">
                            At <strong>Emkan</strong>, our <b>Internal Audit Services</b> At Emkan,We think that an internal audit is a strong instrument for enhancing governance, controlling risks, and enhancing business performance—it is not only a compliance duty.  Businesses are under more and more pressure to maintain accountability, efficiency, and openness in their operations in the rapidly evolving world of today.  To accomplish these objectives, an efficient internal audit offers the knowledge and confidence required.
                            <details>
  <summary>Read More</summary>
  <p>
   
 The scope of our internal audit services extends beyond merely looking at financial data.  In order to make sure your internal controls, procedures, and risk management frameworks are not only compliant but also in line with best practices, we adopt a thorough approach.  Our solutions are customized to your size, structure, and industry, regardless of whether you are an established business or a developing SME.

The scope of our internal audit services extends beyond merely looking at financial data.  In order to make sure your internal controls, procedures, and risk management frameworks are not only compliant but also in line with best practices, we adopt a thorough approach.  Our solutions are customized to your size, structure, and industry, regardless of whether you are an established business or a developing SME.

 To find flaws, gaps, or inefficiencies, Emkan's skilled auditors assess operational workflows, financial processes, and regulatory compliance.  More significantly, we offer concise, useful suggestions that assist management in strengthening internal controls, lowering risks, and increasing productivity.  This turns internal audit into a long-term value generator as well as a control instrument.

Proactive risk management is our main focus.  We assist your company in anticipating dangers before they materialize and creating preventive actions, rather than just detecting issues.  This guarantees that your company will continue to be robust, economical, and more equipped to handle difficulties.

 Since every company functions differently, we offer completely customized internal audit solutions.  We customize our services to match your individual needs, whether you require a thorough analysis of your systems or a targeted evaluation of particular domains like operations, IT, or compliance.

When you work with Emkan, you get more than just an internal auditing service; you get a strategic advisor that encourages openness, fosters confidence, and makes sure your company is always run with strength, honesty, and assurance.
  </p>
</details>

                        </p>
                    </Container>
                </section>

                {/* Services Section */}
                <section style={{ ...sectionStyles, backgroundColor: '#7d94a6ff' }}>
                    <Container>
                        <h2 className="text-white fw-bold text-center mb-5" data-aos="fade-up" >Our Internal Audit Services</h2>
                        <Row className="g-4">
                            {services.map((service, index) => (
                                <Col md={4} key={index} data-aos="zoom-in" data-aos-delay={index * 100}>
                                    <Card
                                        style={cardBaseStyle}
                                        className="p-4 text-center"
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <Card.Body>
                                            <FontAwesomeIcon
                                                icon={service.icon}
                                                className={`fs-1 mb-3 ${service.color || 'text-primary'}`}
                                            />
                                            <h5 className="fw-bold">{service.title}</h5>
                                            <p>{service.description}</p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>

                {/* Why Choose Us Section */}
                <section style={{ ...sectionStyles, backgroundColor: '#7d94a6ff' }}>
                    <Container>
                        <h2 className="text-white fw-bold text-center mb-5" data-aos="fade-up">Why Choose Emkan for Internal Audit?</h2>
                        <Row className="g-4">
                            {reasons.map((reason, index) => (
                                <Col md={4} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                    <Card
                                        style={cardBaseStyle}
                                        className="p-4"
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <Card.Body>
                                            <h5 className="fw-bold">{reason.title}</h5>
                                            <p>{reason.description}</p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>

                {/* CTA Section */}
                {/* <section style={{ ...sectionStyles, backgroundColor: '#f8f9fa', textAlign: 'center' }}>
                    <Container data-aos="fade-up">
                        <h2 className="fw-bold text-primary mb-4">Build Resilient and Transparent Operations</h2>
                        <p className="lead mb-4">Leverage our Internal Audit expertise to drive growth, efficiency, and trust in your organization.</p>
                      <a href="mailto:gcctax@emkanaccounting.com" className="text-decoration-none text-dark fw-bold">
                                        gcctax@emkanaccounting.com
                                        </a>
                    </Container>
                </section> */}
            </main>

            {/* <Footer /> */}
        </>
    );
};

export default InternalAudit;
